export const UI_SETTINGS_KEY = "uiSettings";
export const USERNAME_KEY = "loginUsername";
export const BEAM_BOT = "beam_bot";
export const ORIGIN = "origin";
export const DEVICE = "device";
export const OS = "os";
